import { lazy } from 'react';

const CreateFolder = lazy(() => import('./CreateFolder'));
const Delete = lazy(() => import('./Delete'));
const Rename = lazy(() => import('./Rename'));
const CloneAudience = lazy(() => import('./CloneAudience'));
const MoveItem = lazy(() => import('./MoveItem'));
const ReportError = lazy(() => import('./ReportError'));
const AudiencePreview = lazy(() => import('./AudiencePreview'));
const SaveAudience = lazy(() => import('./SaveAudience'));
const ClearQueryConfirm = lazy(() => import('./ClearQueryConfirm'));
const RequireMissingItem = lazy(() => import('./RequireMissingItem'));
const CreateSupportTicket = lazy(() => import('./CreateSupportTicket'));
const UserPreview = lazy(() => import('./UserPreview'));
const ShareAudience = lazy(() => import('./ShareAudience'));
const CopyAudience = lazy(() => import('./CopyAudience'));
const SessionExpired = lazy(() => import('./SessionExpired'));
const DataSourceConfirm = lazy(() => import('./DataSourceConfirm'));

const modalTypes = {
  CreateFolder,
  CloneAudience,
  Delete,
  Rename,
  MoveItem,
  ReportError,
  AudiencePreview,
  SaveAudience,
  ClearQueryConfirm,
  RequireMissingItem,
  CreateSupportTicket,
  UserPreview,
  ShareAudience,
  CopyAudience,
  SessionExpired,
  DataSourceConfirm,
};

export default modalTypes;
